import { useUserProvider } from '../components/Context/UserContext'

/** Help content is configured by article key; absent articles have no link. */
export function useHelpCenterUrl(article: string) {
  const { subscription } = useUserProvider()
  const value = subscription?.helpArticleUrls?.[article]
  if (!value) return ''
  try {
    const url = new URL(value)
    return url.protocol === 'https:' ? url.href : ''
  } catch {
    return ''
  }
}
